import { Component, Input, OnInit } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { StorePage } from 'src/app/pages/store/store.page';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { WebBlocker } from '../../decorators/web-blocker.decorator';

/**
 * Modal "sem cenoura/spark" do Elogio (Compliment) — mesmo formato do Super Like.
 * Só mostra o CTA de compra; o X (dismiss) volta para a tela de escrita do Elogio.
 * Ao comprar, vai para a loja registrando o evento crrtFromIntro.
 */
@Component({
  selector: 'app-compliment-modal',
  templateUrl: './compliment-modal.component.html',
  styleUrls: ['./compliment-modal.component.scss'],
})
export class ComplimentModalComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() userData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() theSoul: any;
  @Input() srcIcon: string = 'assets/imgs/icon-elogio.svg';

  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private analytics: AnalyticsService,
  ) {}

  get soulName(): string {
    return this.theSoul?.firstName != null ? this.theSoul.firstName : '';
  }

  get descriptionText(): string {
    return this.translate.instant('sendYourComplimentNow', { name: this.soulName });
  }

  /**
   * Le as cenouras do Preferences ao ABRIR.
   *
   * O `userData` chega por `@Input` de quem abriu o modal — home, profile-display ou
   * recadinho — e carrega o que aquela pagina tinha em MEMORIA, que pode ser de antes de uma
   * compra ou de um gasto. O modal ja relia do Preferences, mas so depois que a loja fechava
   * (`openCurrency`), nunca na abertura. Era o "problema de dado em memoria na pagina do
   * elogio": o saldo exibido era o da pagina de tras.
   *
   * O Preferences e a fonte canonica: e nele que o app inteiro persiste o `USER_DATA`.
   *
   * Best-effort de proposito — se a leitura falhar, fica o que veio por Input, que e melhor
   * que um modal vazio.
   */
  async ngOnInit(): Promise<void> {
    await this.atualizarCenouras();
  }

  private async atualizarCenouras(): Promise<void> {
    try {
      const stored = await Preferences.get({ key: 'USER_DATA' });
      if (!stored?.value) {
        return;
      }
      const atual = JSON.parse(stored.value);
      if (atual?.coins == null) {
        return;
      }
      if (this.userData) {
        this.userData.coins = atual.coins;
      } else {
        this.userData = atual;
      }
    } catch (e) {
      console.warn('compliment-modal: nao consegui reler as cenouras. ' + e);
    }
  }

  dismiss() {
    this.modalCtrl.dismiss('cancelled');
  }

  @WebBlocker()
  async openCurrency() {
    const modal = this.modalCtrl.create({
      component: StorePage,
      componentProps: { me: this.userData, type: 'carrot', origin: 'Intro' },
    });
    this.analytics.registerEvent(AnalyticsService.carrots);
    this.analytics.registerEvent(AnalyticsService.crrtFromIntro);
    (await modal).present();

    // Mesma releitura da abertura: um caminho so, para os dois momentos nao divergirem.
    (await modal).onDidDismiss().then(() => this.atualizarCenouras());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onImageError(event: any) {
    console.error('Erro ao carregar imagem:', this.srcIcon, event);
  }
}
